// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button } from '../../../../components';
import styles from './styles';

const ArrangeCollection = (props) => {
  const { classes, onPress } = props;
  const text = `If you would like us to contact you to arrange a
  collection from your home or workplace please confirm below`;

  return (
    <div className={classes.container}>
      <p className={classes.text}>{text}</p>
      <Button
        style={classes.button}
        text={'Arrange Collection'}
        onPress={onPress}
      />
    </div>
  );
};

ArrangeCollection.propTypes = {
  classes: PropTypes.object,
  onPress: PropTypes.func,
};

ArrangeCollection.defaultProps = {
  classes: { },
  onPress: () => { },
};

export default withStyles(styles)(ArrangeCollection);
